// Iniciais e cor estavel por nome, usadas no avatar da lista de conversas e no
// nome do remetente dentro da conversa.
//
// A paleta e a mesma de components/MessagesList (nomes de participantes em
// grupos), replicada aqui porque la ela e uma constante de modulo nao exportada
// e aquele arquivo tem ~5900 linhas acopladas a ticket/whatsapp — nao vale
// importa-lo so por isto.
const SENDER_COLOR_PALETTE = [
  "#e57373", "#f06292", "#ba68c8", "#9575cd", "#7986cb",
  "#5c9ce6", "#039be5", "#0097a7", "#00897b", "#43a047",
  "#7cb342", "#c0a000", "#f57c00", "#ff7043", "#8d6e63",
  "#78909c", "#d81b60", "#8e24aa", "#3949ab", "#00838f",
];

export const getInitials = (value) => {
  if (!value) return "?";
  const words = String(value).trim().split(/\s+/).filter(Boolean);
  if (!words.length) return "?";
  if (words.length === 1) return words[0].charAt(0).toUpperCase();
  return `${words[0].charAt(0)}${words[words.length - 1].charAt(0)}`.toUpperCase();
};

// Hash simples e deterministico: a mesma pessoa/conversa mantem sempre a mesma
// cor entre sessoes e entre usuarios diferentes.
export const colorFromName = (value) => {
  const text = String(value || "");
  let hash = 0;
  for (let i = 0; i < text.length; i++) {
    hash = text.charCodeAt(i) + ((hash << 5) - hash);
  }
  return SENDER_COLOR_PALETTE[Math.abs(hash) % SENDER_COLOR_PALETTE.length];
};

export default SENDER_COLOR_PALETTE;
